export default "__VITE_ASSET__a8c62290__"